import { render, staticRenderFns } from "./AppDeleteAction.vue?vue&type=template&id=33d8a596&scoped=true&"
import script from "./AppDeleteAction.vue?vue&type=script&lang=js&"
export * from "./AppDeleteAction.vue?vue&type=script&lang=js&"
import style0 from "./AppDeleteAction.vue?vue&type=style&index=0&id=33d8a596&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d8a596",
  null
  
)

export default component.exports